import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-check",
  "use": "icon-common-check-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" fill=\"none\" id=\"icon-common-check\">\n    <path d=\"M10.623 3.13672L5.37305 9.13672L3.12305 6.88672\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol